/**
 * @generated SignedSource<<71bbb3362527beb01ad40640e0066aec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IdentityAccountTypes = "CANDIDATE" | "EMPLOYER" | "INTERNAL" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IdentityAccountRow_account$data = {
  readonly accountId: string;
  readonly description: string;
  readonly email: string;
  readonly firstName: string;
  readonly identityId: string;
  readonly lastName: string;
  readonly type: IdentityAccountTypes;
  readonly " $fragmentType": "IdentityAccountRow_account";
};
export type IdentityAccountRow_account$key = {
  readonly " $data"?: IdentityAccountRow_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"IdentityAccountRow_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IdentityAccountRow_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "IdentityAccountModel",
  "abstractKey": null
};

(node as any).hash = "3a9fa679ab5dff84b3de56e32e0fb89a";

export default node;
